import { useSavedCardsQuery, UseSavedCardsQueryReturnType } from "./queries/useSavedCardsQuery";

export type UseSavedCardsByTagsQueryReturnType = {
  getCardsByTags: UseSavedCardsQueryReturnType["getCards"];
  resetCardsByTagsQuery: UseSavedCardsQueryReturnType["resetCardsQuery"];
  cardsByTags: UseSavedCardsQueryReturnType["cards"];
  cardsByTagsTotalCount: UseSavedCardsQueryReturnType["cardsTotalCount"];
  isCardsByTagsSuccess: UseSavedCardsQueryReturnType["isCardsSuccess"];
  isCardsByTagsError: UseSavedCardsQueryReturnType["isCardsError"];
  isCardsByTagsLoading: UseSavedCardsQueryReturnType["isCardsLoading"];
  cancelGetCardsRequest: () => Promise<void>;
};

const GET_SAVED_CARDS_BY_TAGS_FILTER_QUERY_KEY = "get_air_saved_cards_by_tags_filter_query";

export const useSavedCardsByTagsQuery = (): UseSavedCardsByTagsQueryReturnType => {
  const {
    getCards,
    resetCardsQuery,
    cards,
    cardsTotalCount,
    isCardsLoading,
    isCardsSuccess,
    isCardsError,
    cancelGetCardsRequest,
  } = useSavedCardsQuery({
    queryKey: [GET_SAVED_CARDS_BY_TAGS_FILTER_QUERY_KEY],
  });

  return {
    getCardsByTags: getCards,
    resetCardsByTagsQuery: resetCardsQuery,
    cardsByTags: cards,
    cardsByTagsTotalCount: cardsTotalCount,
    isCardsByTagsSuccess: isCardsSuccess,
    isCardsByTagsError: isCardsError,
    isCardsByTagsLoading: isCardsLoading,
    cancelGetCardsRequest,
  };
};
